var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("anil-seat", {
        ref: "myseat",
        attrs: {
          "room-name": "文化宫演艺中心",
          "seat-data": _vm.seatData,
          statusList: _vm.statusList,
          activityAuditStatus: _vm.activityAuditStatus
        },
        on: { createSeat: _vm.createSeat, seatStatus: _vm.seatStatus }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }